import { EuiSpacer } from '@elastic/eui';
import VideoTable from 'components/Web_User_Interface/720p_Series/Multimedia/Video/videoTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  VideoTable,
  BreadCrumbs,
  SEOHelmet,
  React
};